/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * Truncates a user facing string for given constant maximum length.
 * @export
 * @param {string} str The given string to truncate.
 * @param {number} maxLength The max length that this string can be.
 * @returns {string} The truncated string.
 */
export function truncateDisplayString(str: string, maxLength: number): string {
  if (str.length > maxLength) {
    return str.substring(0, maxLength) + '...';
  }
  return str;
}
